export const GALLERY_SECTIONS = {
  PHOTO: 'PHOTO',
  VIDEO: 'VIDEO',
};
